import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useCart } from '../../context/CartContext';
import { useFavorites } from '../../context/FavoritesContext';
import { formatarPrecoUnitario } from '../../utils/precoUnitario';
import './index.scss';

const CardProduto = ({ prod }) => {
    const { userId } = useAuth();
    const { items, addToCart, updateQuantity } = useCart();
    const { favorites, toggleFavorite } = useFavorites();

    const hasVariacoes = Array.isArray(prod.variacoes) && prod.variacoes.length > 0;
    const isFlatVariation = !hasVariacoes && Boolean(prod.id_variacao && prod.id_variacao !== undefined);

    const primeiraVariacao = hasVariacoes
        ? prod.variacoes[0]
        : isFlatVariation
            ? prod
            : null;

    const variacaoDetalhes = primeiraVariacao
        ? {
            ...primeiraVariacao,
            cor: primeiraVariacao.cor ?? prod.cor,
            tamanho: primeiraVariacao.tamanho ?? prod.tamanho,
            material: primeiraVariacao.material ?? prod.material,
            tipo: primeiraVariacao.tipo ?? prod.tipo,
            unidades_por_pacote: primeiraVariacao.unidades_por_pacote ?? prod.unidades_por_pacote,
            preco: primeiraVariacao.preco ?? prod.preco,
            estoque: primeiraVariacao.estoque ?? prod.estoque,
            imagem_principal: primeiraVariacao.imagem_principal ?? prod.imagem_principal
        }
        : null;

    // Se for variação “flat”, prod.id_variacao já é o id da variação.
    // Caso contrário, pegamos primeiraVariacao.id (que vem de v.id).
    const idVariacao = variacaoDetalhes?.id_variacao ?? variacaoDetalhes?.id;

    const produtoId = prod.id
        ?? prod.id_produto
        ?? prod.produto_id
        ?? prod.produtoId
        ?? prod.variacoes?.[0]?.id_produto
        ?? prod.variacoes?.[0]?.produto_id
        ?? prod.variacoes?.[0]?.produtoId;

    const produtoPai = {
        id: produtoId,        // id do produto pai
        nome: prod.nome,     // nome do produto
        imagem_principal: isFlatVariation
            ? prod.imagem_principal
            : '',              // se vier lista de imagens, ajuste conforme necessário
        preco: isFlatVariation
            ? prod.preco
            : ''               // no formato antigo, esse campo viria de prod.variacoes
    };

    const inCart = idVariacao
        ? items.some(item => item.id === idVariacao)
        : false;

    const quantidade = inCart
        ? items.find(item => item.id === idVariacao).quantidade
        : 0;

    const handleQuantityChange = e => {
        if (!idVariacao) return;
        const newQty = Math.max(1, Number(e.target.value) || 0);
        const delta = newQty - quantidade;
        if (delta !== 0) {
            updateQuantity(idVariacao, delta);
        }
    };

    const isFavorito = idVariacao
        ? favorites.includes(idVariacao)
        : false;

    const handleToggleFavorite = () => {
        if (!idVariacao || !userId) return;
        toggleFavorite({ id_usuario: userId, id_variacao: idVariacao });
    };

    const produtoLink = produtoId
        ? `/produto/${produtoId}${idVariacao ? `?variacao=${idVariacao}` : ''}`
        : '/produtos';

    const hasEstoqueInfo = hasVariacoes
        ? prod.variacoes.some(variacao => variacao.estoque !== null && variacao.estoque !== undefined)
        : (variacaoDetalhes?.estoque !== null && variacaoDetalhes?.estoque !== undefined)
            || (prod.estoque !== null && prod.estoque !== undefined);

    const estoqueTotal = hasVariacoes
        ? prod.variacoes.reduce((total, variacao) => total + (Number(variacao.estoque) || 0), 0)
        : Number(variacaoDetalhes?.estoque ?? prod.estoque) || 0;

    const semEstoque = hasEstoqueInfo && estoqueTotal <= 0;

    return (
        <div className={`card-produto ${semEstoque ? 'sem-estoque' : ''}`} key={prod.id}>
            <button
                type="button"
                className={`btn-fav ${isFavorito ? 'active' : ''}`}
                onClick={handleToggleFavorite}
            >
                {isFavorito ? (
                    <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.1667 10.1667C16.4083 8.95 17.6667 7.49167 17.6667 5.58333C17.6667 4.36776 17.1838 3.20197 16.3242 2.34243C15.4647 1.48289 14.2989 1 13.0833 1C11.6167 1 10.5833 1.41667 9.33333 2.66667C8.08333 1.41667 7.05 1 5.58333 1C4.36776 1 3.20197 1.48289 2.34243 2.34243C1.48289 3.20197 1 4.36776 1 5.58333C1 7.5 2.25 8.95833 3.5 10.1667L9.33333 16L15.1667 10.1667Z" fill="#FF0000" stroke="black" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                ) : (
                    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.8333 10.6667C17.075 9.45 18.3333 7.99167 18.3333 6.08333C18.3333 4.86776 17.8504 3.70197 16.9909 2.84243C16.1313 1.98289 14.9655 1.5 13.75 1.5C12.2833 1.5 11.25 1.91667 9.99996 3.16667C8.74996 1.91667 7.71663 1.5 6.24996 1.5C5.03438 1.5 3.86859 1.98289 3.00905 2.84243C2.14951 3.70197 1.66663 4.86776 1.66663 6.08333C1.66663 8 2.91663 9.45833 4.16663 10.6667L9.99996 16.5L15.8333 10.6667Z" stroke="black" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                )}
            </button>

            <Link
                to={produtoLink}
                className="card-link"
            >
                <div className="container-img">
                    <img
                        src={prod.imagem_principal}
                        alt={prod.nome}
                        loading="lazy"
                    />
                </div>
                <h3>{prod.nome}</h3>
                {userId && (
                    <div className="text-preco">
                        R$ {Number(prod.preco || 0).toFixed(2)}
                    </div>
                )}
                {semEstoque && <div className="status-estoque">Sem estoque</div>}
            </Link>

            {variacaoDetalhes && (
                <div className="detalhes-variacao">
                    <p className="descricao-var">
                                {[variacaoDetalhes.cor, variacaoDetalhes.tamanho, variacaoDetalhes.material, variacaoDetalhes.tipo]
                            .filter(Boolean)
                            .join(' / ')}
                    </p>
                            {variacaoDetalhes.unidades_por_pacote && (
                        <div className="unidades-e-preco">
                            <p className="unidades-pacote">
                                        <span className="label">Unit./Pacote:</span> {variacaoDetalhes.unidades_por_pacote}
                                        {userId && variacaoDetalhes.unidades_por_pacote > 1 && (
                                    <>
                                        <span className="separador">|</span>
                                                <span className="label">Preço/Unit.:</span> {formatarPrecoUnitario(prod.preco, variacaoDetalhes.unidades_por_pacote)}
                                    </>
                                )}
                            </p>
                        </div>
                    )}
                </div>
            )}

            {!isFlatVariation &&
                Array.isArray(prod.variacoes) &&
                prod.variacoes.length > 1 && (
                    <select
                        onChange={e => {
                        }}
                    >
                        {prod.variacoes.map(v => (
                            <option key={v.id_variacao} value={v.id_variacao}>
                                {v.tamanho} / {v.cor}
                            </option>
                        ))}
                    </select>
                )}
            {userId ? (
                <div className="dados-produto">
                    <div className="bnt-carrinho">
                        {inCart ? (
                            <div className="controle-carrinho">
                                <div className="check-carrinho" title="Produto no carrinho">
                                    <svg width="46" height="47" viewBox="0 0 46 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18.3085 42.4369C18.3085 44.9466 16.2488 47 13.7313 47C11.2139 47 9.15423 44.9466 9.15423 42.4369C9.15423 39.9272 11.2139 37.8738 13.7313 37.8738C16.2488 37.8738 18.3085 39.9272 18.3085 42.4369ZM36.6169 37.8738C34.0995 37.8738 32.0398 39.9272 32.0398 42.4369C32.0398 44.9466 34.0995 47 36.6169 47C39.1343 47 41.194 44.9466 41.194 42.4369C41.194 39.9272 39.1343 37.8738 36.6169 37.8738ZM14.1891 30.5728V30.3447L16.2488 26.466H33.1841C34.7861 26.466 36.3881 25.5534 37.0746 24.1845L46 8.21359L42.1094 5.93204L33.1841 21.9029H17.1642L7.55224 1.36893H0V5.93204H4.57711L12.8159 23.2718L9.61194 28.7476C9.38308 29.432 9.15423 30.1165 9.15423 31.0291C9.15423 33.5388 11.2139 35.5922 13.7313 35.5922H41.194V31.0291H14.6468C14.4179 31.0291 14.1891 30.801 14.1891 30.5728ZM38.9055 3.19417L35.7015 0L24.7164 10.9515L18.7662 5.01942L15.5622 8.21359L24.7164 17.3398L38.9055 3.19417Z" fill="white" />
                                    </svg>
                                </div>
                                <div className='bnts-prods'>
                                    <button className='bnt-mais' onClick={() => updateQuantity(prod.id_variacao, + 1)}><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.00065 0.958008C7.57565 0.958008 8.04232 1.42467 8.04232 1.99967V5.95801H12.0007C12.2769 5.95801 12.5419 6.06775 12.7372 6.2631C12.9326 6.45846 13.0423 6.72341 13.0423 6.99967C13.0423 7.27594 12.9326 7.54089 12.7372 7.73624C12.5419 7.93159 12.2769 8.04134 12.0007 8.04134H8.04232V11.9997C8.04232 12.2759 7.93257 12.5409 7.73722 12.7362C7.54187 12.9316 7.27692 13.0413 7.00065 13.0413C6.72438 13.0413 6.45943 12.9316 6.26408 12.7362C6.06873 12.5409 5.95898 12.2759 5.95898 11.9997V8.04134H2.00065C1.72438 8.04134 1.45943 7.93159 1.26408 7.73624C1.06873 7.54089 0.958984 7.27594 0.958984 6.99967C0.958984 6.72341 1.06873 6.45846 1.26408 6.2631C1.45943 6.06775 1.72438 5.95801 2.00065 5.95801H5.95898V1.99967C5.95898 1.42467 6.42565 0.958008 7.00065 0.958008Z" fill="white" /><path d="M7.00065 0.958008C7.57565 0.958008 8.04232 1.42467 8.04232 1.99967V5.95801H12.0007C12.2769 5.95801 12.5419 6.06775 12.7372 6.2631C12.9326 6.45846 13.0423 6.72341 13.0423 6.99967C13.0423 7.27594 12.9326 7.54089 12.7372 7.73624C12.5419 7.93159 12.2769 8.04134 12.0007 8.04134H8.04232V11.9997C8.04232 12.2759 7.93257 12.5409 7.73722 12.7362C7.54187 12.9316 7.27692 13.0413 7.00065 13.0413C6.72438 13.0413 6.45943 12.9316 6.26408 12.7362C6.06873 12.5409 5.95898 12.2759 5.95898 11.9997V8.04134H2.00065C1.72438 8.04134 1.45943 7.93159 1.26408 7.73624C1.06873 7.54089 0.958984 7.27594 0.958984 6.99967C0.958984 6.72341 1.06873 6.45846 1.26408 6.2631C1.45943 6.06775 1.72438 5.95801 2.00065 5.95801H5.95898V1.99967C5.95898 1.42467 6.42565 0.958008 7.00065 0.958008Z" fill="white" /></svg></button>
                                    <div className='input-qtd'>
                                        <input
                                            type="number"
                                            min="1"
                                            value={quantidade}
                                            onChange={handleQuantityChange}
                                        />
                                    </div>
                                    <button className='bnt-menos' onClick={() => updateQuantity(prod.id_variacao, - 1)}><svg width="13" height="3" viewBox="0 0 13 3" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.38932 0H5.34766H11.3893C11.6656 0 11.9305 0.109747 12.1259 0.305097C12.3212 0.500447 12.431 0.765399 12.431 1.04167C12.431 1.31793 12.3212 1.58289 12.1259 1.77824C11.9305 1.97359 11.6656 2.08333 11.3893 2.08333H7.43099H1.38932C1.11306 2.08333 0.848104 1.97359 0.652753 1.77824C0.457403 1.58289 0.347656 1.31793 0.347656 1.04167C0.347656 0.765399 0.457403 0.500447 0.652753 0.305097C0.848104 0.109747 1.11306 0 1.38932 0Z" fill="white" /></svg></button>
                                </div>
                            </div>
                        ) : (
                            <button
                                className="add-cart"
                                disabled={semEstoque}
                                onClick={() => {
                                    const varId = variacaoDetalhes.id_variacao ?? variacaoDetalhes.id;
                                    addToCart({
                                        id: varId,
                                        id_produto: prod.id,
                                        nome: produtoPai.nome,
                                        preco: variacaoDetalhes.preco,
                                        imagem_principal: variacaoDetalhes.imagem_principal,
                                        cor: variacaoDetalhes.cor,
                                        tamanho: variacaoDetalhes.tamanho,
                                        material: variacaoDetalhes.material,
                                        tipo: variacaoDetalhes.tipo,
                                        estoque: variacaoDetalhes.estoque ?? prod.estoque ?? 0,
                                        unidades_por_pacote: variacaoDetalhes.unidades_por_pacote,
                                        quantidade: 1
                                    });
                                }}
                            >
                                <svg width="45" height="47" viewBox="0 0 45 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M22.3214 17.9048H26.7857V11.1905H33.4821V6.71429H26.7857V0H22.3214V6.71429H15.625V11.1905H22.3214V17.9048ZM13.3929 38.0476C10.9375 38.0476 8.95089 40.0619 8.95089 42.5238C8.95089 44.9857 10.9375 47 13.3929 47C15.8482 47 17.8571 44.9857 17.8571 42.5238C17.8571 40.0619 15.8482 38.0476 13.3929 38.0476ZM35.7143 38.0476C33.2589 38.0476 31.2723 40.0619 31.2723 42.5238C31.2723 44.9857 33.2589 47 35.7143 47C38.1696 47 40.1786 44.9857 40.1786 42.5238C40.1786 40.0619 38.1696 38.0476 35.7143 38.0476ZM15.8482 26.8571H32.4777C34.1518 26.8571 35.625 25.9395 36.3839 24.5519L45 8.86286L41.1161 6.71429L32.4777 22.381H16.808L7.29911 2.2381H0V6.71429H4.46429L12.5 23.7014L9.48661 29.1624C7.85714 32.1614 10 35.8095 13.3929 35.8095H40.1786V31.3333H13.3929L15.8482 26.8571Z" fill="white" />
                                </svg>
                                {semEstoque ? 'Indisponivel' : 'Adicionar ao carrinho'}
                            </button>
                        )}
                    </div>
                </div>
            ) : (
                <a
                    className="botao-whatsapp"
                    href={`https://wa.me/5511997636154?text=Olá!%20Tenho%20interesse%20no%20produto%20${encodeURIComponent(
                        prod.nome
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <svg width="39" height="39" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.907305 38.4919L10.6554 35.9295C13.3885 37.4 16.4537 38.1814 19.575 38.1814C29.9506 38.1814 38.4063 29.7257 38.4063 19.3501C38.4063 14.3154 36.4489 9.58321 32.896 6.03C31.1535 4.27058 29.0782 2.87553 26.7912 1.92613C24.5041 0.976711 22.0509 0.491952 19.5746 0.500101C9.1992 0.500327 0.74375 8.95592 0.74375 19.3314C0.74375 22.6216 1.59953 25.8188 3.20039 28.6466L0.602537 38.1844L0.488825 38.6019L0.907305 38.4919ZM11.074 32.0458L5.64271 33.4733L7.08492 28.1909L7.11431 28.0833L7.05382 27.9896L6.68061 27.4111C6.68032 27.4107 6.68002 27.4102 6.67972 27.4097C5.16309 24.988 4.35796 22.1886 4.35625 19.3312C4.35633 10.9568 11.1819 4.13135 19.5562 4.13135C23.6148 4.13135 27.4322 5.71737 30.2914 8.59506L30.2924 8.59606C31.7082 10.005 32.8302 11.681 33.5933 13.5268C34.3563 15.3727 34.7452 17.3518 34.7375 19.3491L34.7375 19.3512C34.7744 27.7242 27.95 34.5313 19.575 34.5313C16.8453 34.5313 14.1707 33.7937 11.8278 32.4102C11.8276 32.4101 11.8273 32.41 11.8271 32.4098L11.2661 32.0732L11.1758 32.019L11.074 32.0458ZM24.9759 21.4812L24.976 21.4809L24.9634 21.4765C24.7563 21.4044 24.5203 21.3256 24.2865 21.3516C24.0258 21.3806 23.8138 21.5297 23.6272 21.7931L23.6272 21.7931L23.6245 21.797C23.3154 22.2516 22.4437 23.2911 22.1806 23.5917L22.1805 23.5917L22.1758 23.5974C22.0698 23.7261 21.9875 23.7663 21.9111 23.7752C21.8228 23.7854 21.6893 23.7603 21.4716 23.647L21.4716 23.6469L21.4644 23.6435C21.3926 23.609 21.2997 23.569 21.1877 23.5208C20.5419 23.2427 19.2653 22.6931 17.7916 21.3762L17.7914 21.376C16.4373 20.1683 15.5357 18.6819 15.2539 18.2123C15.1512 18.0276 15.1622 17.926 15.186 17.8597C15.2181 17.7704 15.2928 17.6858 15.4205 17.5581C15.5694 17.4093 15.75 17.191 15.9171 16.9891C15.9912 16.8996 16.0625 16.8134 16.1273 16.7378C16.354 16.4733 16.4627 16.2545 16.5919 15.9945C16.6043 15.9694 16.6169 15.944 16.6299 15.9182L16.6299 15.9182L16.6325 15.9128C16.8283 15.4966 16.7223 15.1481 16.5924 14.8883C16.4859 14.6753 15.5537 12.4018 15.1759 11.4573L15.1759 11.4572L15.1745 11.4539C14.9754 10.9759 14.7503 10.7154 14.4919 10.5912C14.2953 10.4967 14.0831 10.4959 13.9689 10.4955C13.9446 10.4954 13.9247 10.4954 13.9104 10.4944L13.9021 10.4939H13.8938H12.9937C12.6168 10.4939 12.0583 10.6276 11.5723 11.1558L11.5722 11.1558L11.5686 11.1599C11.5373 11.1955 11.501 11.2353 11.4607 11.2795C10.9727 11.8146 9.89375 12.9977 9.89375 15.2064C9.89375 16.4064 10.33 17.5724 10.7834 18.4649C11.2339 19.3517 11.7123 19.9895 11.8338 20.1514L11.8352 20.1533C11.8448 20.167 11.8592 20.1881 11.8783 20.216C12.3252 20.8701 15.3513 25.2985 19.8688 27.248C20.9859 27.7402 21.8577 28.0246 22.5376 28.2324C23.6943 28.6045 24.749 28.5438 25.5721 28.429L25.5736 28.4287C26.0709 28.3562 26.794 28.0562 27.4352 27.644C28.0696 27.2362 28.6879 26.6778 28.9045 26.0521C29.1083 25.4887 29.2114 24.9663 29.246 24.553C29.2633 24.3465 29.2639 24.1631 29.2499 24.013C29.237 23.8749 29.209 23.7272 29.1422 23.6221C29.0413 23.4636 28.8914 23.3636 28.7346 23.2802C28.6417 23.2307 28.5264 23.1775 28.4003 23.1193C28.3228 23.0835 28.2412 23.0458 28.1582 23.006C28.0479 22.9531 27.8306 22.8471 27.5582 22.7144C26.7 22.2963 25.2959 21.6121 24.9759 21.4812ZM25.5375 28.1815L25.5375 28.1815L25.5375 28.1815Z" stroke-width="0.5" /></svg>Chamar no WhatsApp
                </a>
            )}
        </div>
    );
};

export default CardProduto;